import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CreatableSelect from 'react-select/lib/Creatable';

const propTypes = {
  placeholder: PropTypes.string,
  formatCreateLabelText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  savedValues: PropTypes.instanceOf(Array),
  inputValue: PropTypes.string,
  onCreateOption: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func.isRequired,
  isValid: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  isClearable: PropTypes.bool,
  classNamePrefix: PropTypes.string,
};

const defaultProps = {
  placeholder: '',
  formatCreateLabelText: '',
  selectedValue: '',
  savedValues: [],
  inputValue: '',
  isValid: false,
  noOptionsMessage: null,
  isClearable: true,
  classNamePrefix: '',
};

export class EditableDropdown extends Component {
  formatOption(option) {
    return {
      value: option.toString(),
      label: option.toString(),
    };
  }

  formatOptions(options) {
    return options.map(option => this.formatOption(option));
  }

  controlBorderColor(isValid, state) {
    if (isValid) return '#E6E9EB';
    if (state.isSelected) return '#4E5F6B';
    return '#F73F21';
  }

  optionBackgroundColor(state) {
    if (state.isFocused) return '#F3F7F8';
    if (state.isSelected) return '#E7EFF2';
    return null;
  }

  render() {
    const {
      placeholder,
      formatCreateLabelText,
      onChange,
      selectedValue,
      savedValues,
      inputValue,
      onCreateOption,
      onInputChange,
      onMenuOpen,
      isValid,
      noOptionsMessage,
      isClearable,
      classNamePrefix,
    } = this.props;

    // https://react-select.com/styles
    const customStyles = {
      control: (base, state) => ({
        ...base,
        width: 300,
        boxShadow: 'none',
        borderColor: `${this.controlBorderColor(isValid, state)} !important`, // isValid ? '#E6E9EB !important' : '#F73F21 !important',
        borderRadius: 0,
        fontSize: '14px',
        padding: 10,
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E9EB',
      }),
      placeholder: base => ({
        ...base,
        color: '#717171',
      }),
      clearIndicator: base => ({
        ...base,
        color: '#00A9E0',
      }),
      indicatorSeparator: base => ({
        ...base,
        backgroundColor: '#FFFFFF',
      }),
      dropdownIndicator: base => ({
        ...base,
        color: '#00A9E0',
      }),
      menu: base => ({
        ...base,
        width: 300,
        boxShadow: 'none',
        margin: 0,
        borderRadius: 0,
        border: '1px solid #E6E9EB',
        borderTop: 0,
      }),
      option: (base, state) => ({
        ...base,
        padding: '15px 20px',
        borderBottom: '1px solid #A5ACB5',
        color: '#000000 !important',
        backgroundColor: '#FFFFFF', // this.optionBackgroundColor(state),
      }),
    };

    return (
      <CreatableSelect
        isClearable={isClearable}
        styles={customStyles}
        placeholder={placeholder}
        formatCreateLabel={newValue => `+ ${formatCreateLabelText} "${newValue}"`}
        createOptionPosition="first"
        onChange={onChange}
        value={this.formatOption(selectedValue)}
        options={this.formatOptions(savedValues)}
        inputValue={inputValue}
        onInputChange={onInputChange}
        onCreateOption={onCreateOption}
        onMenuOpen={onMenuOpen}
        noOptionsMessage={() => noOptionsMessage}
        onBlur={onChange}
        classNamePrefix={classNamePrefix}
      />
    );
  }
}

EditableDropdown.propTypes = propTypes;
EditableDropdown.defaultProps = defaultProps;
export default EditableDropdown;
